import React, { useState, useEffect, useRef } from "react";
import { Box, Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import VisitService from "../services/VisitService";

import { useStore } from '../Store'

import useOnlineStatus from '../hooks/useOnlineStatus'
import Header from "./Header";
import YearFilter from "./YearFilter"
import PlotFilter from "./PlotFilter"
import VisitList from "./VisitList"
import BottomNavigationCustom from './BottomNavigationCustom'

import { useConfirm } from './ConfirmDialog'
import { useToaster } from "./Toaster";

const Visits = ({ history }) => {
  const isOnline = useOnlineStatus()
  const { confirm } = useConfirm()
  const { showError, showMessage } = useToaster()

  const [visits, setVisits] = useState([])
  const [loading, setLoading] = useState(false)
  const { createVisit, deleteUnsaved, year, plot, plots, setPlot, setPlots, unsaved } = useStore()

  const showErrorRef = useRef(showError)
  const setPlotsRef = useRef(setPlots)

  useEffect(() => {

    const fetchData = async () => {
      try {
        setLoading(true)
        setVisits([])
        const response = await VisitService.getVisits(year, plot)
        setVisits(response.data)
        setLoading(false)
      }
      catch (error) {
        if (error.response && error.response.status === 401) history.push('/login')
        showErrorRef.current(error)
        setLoading(false)
      }
    }

    if (!isOnline) {
      setVisits([])
    } else {
      fetchData()
    }
  }, [year, plot, isOnline, unsaved])

  useEffect(() => {
    const fetchData = async () => {
      if (parseInt(process.env.REACT_APP_PROJECTID) === 61) {
        await setPlotsRef.current();
      }
    }
    if (isOnline) fetchData()

  }, [isOnline])

  const addVisit = () => {
    if (parseInt(process.env.REACT_APP_PROJECTID) === 61 && plot === -1) {
      showError("Kies een locatie die u wilt bezoeken")
      return
    }
    if (parseInt(process.env.REACT_APP_PROJECTID) === 57 && plot === -1) {
      showError("Kies een cluster/object die u wilt bezoeken")
      return
    }
    if (parseInt(process.env.REACT_APP_PROJECTID) === 46 && plot === -1) {
      showError("Kies een telgebied die u wilt bezoeken")
      return
    }
    const newVisit = createVisit()
    history.push({ pathname: '/details', state: { visit: newVisit } })
  }

  const selectVisit = (visit) => {
    if (visit.offline) {
      history.push({ pathname: '/details', state: { visit: visit } })
    } else {
      if (isOnline) {
        VisitService.getVisit(visit.id)
          .then((response) => {
            history.push({ pathname: '/details', state: { visit: response.data } })
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) history.push('/login')
            showError(error)
          })
      } else {
        showError("Bezoek kan niet gewijzigd worden in offline modus")
      }
    }
  }

  const handleDelete = async (visit) => {
    const canDelete = await confirm(`Wilt u bezoek ${visit.description} verwijderen?`)
    if (canDelete) {
      if (visit.id > 0) {
        if (isOnline) {
          VisitService.deleteVisit(visit)
            .then((response) => {
              showMessage("bezoek verwijderd")
              deleteUnsaved(visit)
              setVisits(visits.filter(item => item.id !== visit.id))
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) history.push('/login')
              showError(error)
            })
        } else {
          showError("Bezoek kan niet verwijderd worden in offline modus")
        }
      } else {
        deleteUnsaved(visit)
        setVisits(visits.filter(item => item.id !== visit.id))
      }
    }
  }

  return (
    <>
      <Header title="Bezoeken" />
      <Box m={2}>
        <YearFilter />
        <PlotFilter plot={plot} plots={plots} setPlot={setPlot} />
        <VisitList
          onSelect={selectVisit}
          onDelete={handleDelete}
          visits={[...unsaved.filter(item => ('observations' in item)), ...visits.filter(v1 => !unsaved.some(v2 => v2.id === v1.id)).sort((a, b) => (a.timeStart < b.timeStart ? 1 : -1))]}
          loading={loading}
        />
        {plots.length > 0 && <Fab color="secondary" aria-label="add" onClick={addVisit}>
          <AddIcon />
        </Fab>}
      </Box>
      <BottomNavigationCustom />
    </>
  )
}

export default Visits